import {useState} from 'react'
import {Time} from 'yougile-util'
import {
  createDataObjectId,
  DataObjectId,
  DealActivityDealItem,
  DealActivityItemBase,
  DealActivityNoteItem,
  DealActivityType,
  Hub
} from 'yougile-model'
import {globals} from '@extensions/globals-base'

interface ReturnType {
  sendMessage: (props: {deadline: number; assigned: DataObjectId[]}) => void
  input: string
  setInput: (value: string) => void
}

interface Props {
  hub: Hub
  typeActivity: DealActivityType
}

export const useSendMessageAction = (props: Props): ReturnType => {
  const {hub, typeActivity} = props
  const [input, setInput] = useState('')

  const sendMessage = (props: {
    deadline: number
    assigned: DataObjectId[]
  }): void => {
    if (!input.trim()) {
      return
    }

    const {deadline, assigned} = props

    const activity = createDealActivity({
      typeActivity,
      deadline,
      input,
      assigned
    })

    hub.data ??= {}
    hub.data.dealActivity ??= {}
    hub.data.dealActivity[activity.id] = activity

    hub.commit()
    setInput('')
  }

  return {sendMessage, input, setInput}
}

const createDealActivity = (props: {
  typeActivity: DealActivityType
  input: string
  deadline: number
  assigned: DataObjectId[]
}): DealActivityDealItem | DealActivityNoteItem => {
  const {typeActivity, deadline, input, assigned} = props

  const activity: DealActivityItemBase = {
    id: createDataObjectId(),
    timestamp: Time.now(),
    from: globals.currentUserId,
    type: typeActivity
  }

  if (typeActivity === 'deal') {
    const dealActivity: DealActivityDealItem = {
      ...activity,
      deadline,
      assigned,
      text: input.trim(),
      type: typeActivity
    }
    return dealActivity
  }

  if (typeActivity === 'note') {
    const noteActivity: DealActivityNoteItem = {
      ...activity,
      text: input.trim(),
      type: typeActivity
    }
    return noteActivity
  }

  throw new Error('Invalid typeActivity')
}
